import { } from "../../node_modules/jquery/dist/jquery.min";
import * as navbar from "./navbar.mjs";
import * as swipers from "./swipers.mjs";
import * as countries from "./countries.mjs";
import * as brands from "./brands.mjs";
import * as read_more from "./read_more.mjs";
import * as anchors from "./anchors.mjs";
import * as distributor_list from "./distributor-list.mjs"
import * as resources from "./resources.mjs"
import * as flower_nav from "./flower_nav.mjs"

navbar.init();
swipers.init();
countries.init();
brands.init();
read_more.init();
anchors.init();
distributor_list.init();
resources.init();
flower_nav.init();
